import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import ProductUpdatesHost from './components/ProductUpdatesHost.vue';

export const productUpdatesModule = createModuleBuilder()
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .registerTopLevelComponent(ProductUpdatesHost)
    .end();
